export { default as IconAccountSettings } from './svg/account-settings.svg';
export { default as IconAccount } from './svg/account.svg';
export { default as IconActive } from './svg/active.svg';
export { default as IconAddShoppingCart } from './svg/add-shopping-cart.svg';
export { default as IconAlert } from './svg/alert.svg';
export { default as IconAlignJustify } from './svg/align-justify.svg';
export { default as IconAlignLeft } from './svg/align-left.svg';
export { default as IconAlignRight } from './svg/align-right.svg';
export { default as IconAlign } from './svg/align.svg';
export { default as IconAnchor } from './svg/anchor.svg';
export { default as IconArchive } from './svg/archive.svg';
export { default as IconArrowCircleDown } from './svg/arrow-circle-down.svg';
export { default as IconArrowCircleLeft } from './svg/arrow-circle-left.svg';
export { default as IconArrowCircleRight } from './svg/arrow-circle-right.svg';
export { default as IconArrowCircleUp } from './svg/arrow-circle-up.svg';
export { default as IconArrowDown } from './svg/arrow-down.svg';
export { default as IconArrowLeftDown } from './svg/arrow-left-down.svg';
export { default as IconArrowLeftUp } from './svg/arrow-left-up.svg';
export { default as IconArrowLeft } from './svg/arrow-left.svg';
export { default as IconArrowRightDown } from './svg/arrow-right-down.svg';
export { default as IconArrowRightUp } from './svg/arrow-right-up.svg';
export { default as IconArrowRight } from './svg/arrow-right.svg';
export { default as IconArrowUp } from './svg/arrow-up.svg';
export { default as IconAt } from './svg/at.svg';
export { default as IconAttachment } from './svg/attachment.svg';
export { default as IconAward } from './svg/award.svg';
export { default as IconBagage } from './svg/bagage.svg';
export { default as IconBed } from './svg/bed.svg';
export { default as IconBell } from './svg/bell.svg';
export { default as IconBike } from './svg/bike.svg';
export { default as IconBluetooth } from './svg/bluetooth.svg';
export { default as IconBook } from './svg/book.svg';
export { default as IconBox } from './svg/box.svg';
export { default as IconBulletCircle } from './svg/bullet-circle.svg';
export { default as IconBulletPoint } from './svg/bullet-point.svg';
export { default as IconCalendarAlt } from './svg/calendar-alt.svg';
export { default as IconCalendarComplete } from './svg/calendar-complete.svg';
export { default as IconCalendarRounded } from './svg/calendar-rounded.svg';
export { default as IconCalendar } from './svg/calendar.svg';
export { default as IconCamera } from './svg/camera.svg';
export { default as IconCardAlt } from './svg/card-alt.svg';
export { default as IconCard } from './svg/card.svg';
export { default as IconCharge } from './svg/charge.svg';
export { default as IconChart1 } from './svg/chart-1.svg';
export { default as IconChart2 } from './svg/chart-2.svg';
export { default as IconChat } from './svg/chat.svg';
export { default as IconCheckCircle } from './svg/check-circle.svg';
export { default as IconCheckSquare } from './svg/check-square.svg';
export { default as IconCheck } from './svg/check.svg';
export { default as IconCheckmarkCircle } from './svg/checkmark-circle.svg';
export { default as IconCheers } from './svg/cheers.svg';
export { default as IconChevronDown } from './svg/chevron-down.svg';
export { default as IconChevronLeft } from './svg/chevron-left.svg';
export { default as IconChevronRight } from './svg/chevron-right.svg';
export { default as IconChevronUp } from './svg/chevron-up.svg';
export { default as IconChevronsDown } from './svg/chevrons-down.svg';
export { default as IconChevronsLeft } from './svg/chevrons-left.svg';
export { default as IconChevronsRight } from './svg/chevrons-right.svg';
export { default as IconChevronsUp } from './svg/chevrons-up.svg';
export { default as IconCircle } from './svg/circle.svg';
export { default as IconClipboardFilled } from './svg/clipboard-filled.svg';
export { default as IconClipboard } from './svg/clipboard.svg';
export { default as IconClockFilled } from './svg/clock-filled.svg';
export { default as IconClockTimeBack } from './svg/clock-time-back.svg';
export { default as IconClock } from './svg/clock.svg';
export { default as IconClose } from './svg/close.svg';
export { default as IconCloudDrizzle } from './svg/cloud-drizzle.svg';
export { default as IconCloudLightRain } from './svg/cloud-light-rain.svg';
export { default as IconCloudLightning } from './svg/cloud-lightning.svg';
export { default as IconCloudRain } from './svg/cloud-rain.svg';
export { default as IconCloud } from './svg/cloud.svg';
export { default as IconCode } from './svg/code.svg';
export { default as IconCoffee } from './svg/coffee.svg';
export { default as IconCompas } from './svg/compas.svg';
export { default as IconCornerDownLeft } from './svg/corner-down-left.svg';
export { default as IconCornerDownRight } from './svg/corner-down-right.svg';
export { default as IconCornerLeftDown } from './svg/corner-left-down.svg';
export { default as IconCornerLeftUp } from './svg/corner-left-up.svg';
export { default as IconCornerRightDown } from './svg/corner-right-down.svg';
export { default as IconCornerRightUp } from './svg/corner-right-up.svg';
export { default as IconCornerUpLeft } from './svg/corner-up-left.svg';
export { default as IconCornerUpRight } from './svg/corner-up-right.svg';
export { default as IconCounting } from './svg/counting.svg';
export { default as IconCross } from './svg/cross.svg';
export { default as IconDecrease } from './svg/decrease.svg';
export { default as IconDiamond } from './svg/diamond.svg';
export { default as IconDiner } from './svg/diner.svg';
export { default as IconDiscount } from './svg/discount.svg';
export { default as IconDot } from './svg/dot.svg';
export { default as IconDryCleaning } from './svg/dry-cleaning.svg';
export { default as IconEdit3 } from './svg/edit-3.svg';
export { default as IconEdit } from './svg/edit.svg';
export { default as IconElectric } from './svg/electric.svg';
export { default as IconEmail } from './svg/email.svg';
export { default as IconEuro } from './svg/euro.svg';
export { default as IconExternalLink } from './svg/external-link.svg';
export { default as IconExtreme } from './svg/extreme.svg';
export { default as IconEye } from './svg/eye.svg';
export { default as IconEyeOff } from './svg/eye-off.svg';
export { default as IconFacebook } from './svg/facebook.svg';
export { default as IconFastForward } from './svg/fast-forward.svg';
export { default as IconFilm } from './svg/film.svg';
export { default as IconFilter } from './svg/filter.svg';
export { default as IconFlag } from './svg/flag.svg';
export { default as IconFolder } from './svg/folder.svg';
export { default as IconForkKnife } from './svg/fork-knife.svg';
export { default as IconGift } from './svg/gift.svg';
export { default as IconGlobe } from './svg/globe.svg';
export { default as IconGoogle } from './svg/google.svg';
export { default as IconGrade } from './svg/grade.svg';
export { default as IconGrid } from './svg/grid.svg';
export { default as IconHash } from './svg/hash.svg';
export { default as IconHeadphones } from './svg/headphones.svg';
export { default as IconHealing } from './svg/healing.svg';
export { default as IconHeart } from './svg/heart.svg';
export { default as IconHeartPlus } from './svg/heart-plus.svg';
export { default as IconHelpCircle } from './svg/help-circle.svg';
export { default as IconHomeAlt } from './svg/home-alt.svg';
export { default as IconHome } from './svg/home.svg';
export { default as IconHotelSpa } from './svg/hotel-spa.svg';
export { default as IconIncrease } from './svg/increase.svg';
export { default as IconInfo } from './svg/info.svg';
export { default as IconInfoFilled } from './svg/info-filled.svg';
export { default as IconImage } from './svg/image.svg';
export { default as IconInstagram } from './svg/instagram.svg';
export { default as IconLabel } from './svg/label.svg';
export { default as IconLayers } from './svg/layers.svg';
export { default as IconLightBulb } from './svg/light-bulb.svg';
export { default as IconLink } from './svg/link.svg';
export { default as IconLinkedin } from './svg/linkedin.svg';
export { default as IconListFilled } from './svg/list-filled.svg';
export { default as IconLoading } from './svg/loading.svg';
export { default as IconLocation } from './svg/location.svg';
export { default as IconLocationFilled } from './svg/location-filled.svg';
export { default as IconLock } from './svg/lock.svg';
export { default as IconLogIn } from './svg/log-in.svg';
export { default as IconLogOut } from './svg/log-out.svg';
export { default as IconLogoMark } from './svg/logo-mark.svg';
export { default as IconLogout } from './svg/logout.svg';
export { default as IconMail } from './svg/mail.svg';
export { default as IconMaleFemale } from './svg/male-female.svg';
export { default as IconMan } from './svg/man.svg';
export { default as IconManAndWoman } from './svg/man-and-woman.svg';
export { default as IconMap } from './svg/map.svg';
export { default as IconMassage } from './svg/massage.svg';
export { default as IconMaximize2 } from './svg/maximize-2.svg';
export { default as IconMaximize } from './svg/maximize.svg';
export { default as IconMenu } from './svg/menu.svg';
export { default as IconMessage } from './svg/message.svg';
export { default as IconMin } from './svg/min.svg';
export { default as IconMinus } from './svg/minus.svg';
export { default as IconMix } from './svg/mix.svg';
export { default as IconMoon } from './svg/moon.svg';
export { default as IconMoreVertical } from './svg/more-vertical.svg';
export { default as IconMove } from './svg/move.svg';
export { default as IconMug } from './svg/mug.svg';
export { default as IconNavigation } from './svg/navigation.svg';
export { default as IconNoCamera } from './svg/no-camera.svg';
export { default as IconNoVideo } from './svg/no-video.svg';
export { default as IconOpties1 } from './svg/opties1.svg';
export { default as IconOptions } from './svg/options.svg';
export { default as IconPackage } from './svg/package.svg';
export { default as IconPencil } from './svg/pencil.svg';
export { default as IconPercentage } from './svg/percentage.svg';
export { default as IconPersons } from './svg/persons.svg';
export { default as IconPhone } from './svg/phone.svg';
export { default as IconPlay } from './svg/play.svg';
export { default as IconPlusCircleFilled } from './svg/plus-circle-filled.svg';
export { default as IconPlusCircle } from './svg/plus-circle.svg';
export { default as IconPlusSquare } from './svg/plus-square.svg';
export { default as IconPlus } from './svg/plus.svg';
export { default as IconPocket } from './svg/pocket.svg';
export { default as IconPower } from './svg/power.svg';
export { default as IconPreferences } from './svg/preferences.svg';
export { default as IconPrinter } from './svg/printer.svg';
export { default as IconProfile } from './svg/profile.svg';
export { default as IconQrCodeScanner } from './svg/qr-code-scanner.svg';
export { default as IconQuestionMarkCircle } from './svg/question-mark-circle.svg';
export { default as IconQuote } from './svg/quote.svg';
export { default as IconRadio } from './svg/radio.svg';
export { default as IconRedeem } from './svg/redeem.svg';
export { default as IconRefreshCcw } from './svg/refresh-ccw.svg';
export { default as IconRefreshCw } from './svg/refresh-cw.svg';
export { default as IconRelaxation } from './svg/relaxation.svg';
export { default as IconRepeat } from './svg/repeat.svg';
export { default as IconRestaurant } from './svg/restaurant.svg';
export { default as IconRewind } from './svg/rewind.svg';
export { default as IconRotateCcw } from './svg/rotate-ccw.svg';
export { default as IconRotateCw } from './svg/rotate-cw.svg';
export { default as IconRss } from './svg/rss.svg';
export { default as IconScanBarcode } from './svg/scan-barcode.svg';
export { default as IconScent } from './svg/scent.svg';
export { default as IconScissors } from './svg/scissors.svg';
export { default as IconSearch } from './svg/search.svg';
export { default as IconSend } from './svg/send.svg';
export { default as IconServer } from './svg/server.svg';
export { default as IconSettings } from './svg/settings.svg';
export { default as IconShare2 } from './svg/share-2.svg';
export { default as IconShare } from './svg/share.svg';
export { default as IconShield } from './svg/shield.svg';
export { default as IconShoppingBagHigh } from './svg/shopping-bag-high.svg';
export { default as IconShoppingBagLow } from './svg/shopping-bag-low.svg';
export { default as IconShoppingCart } from './svg/shopping-cart.svg';
export { default as IconSliders } from './svg/sliders.svg';
export { default as IconSound } from './svg/sound.svg';
export { default as IconStar } from './svg/star.svg';
export { default as IconStarHalf } from './svg/star-half.svg';
export { default as IconStarOutline } from './svg/star-outline.svg';
export { default as IconStressManagement } from './svg/stress-management.svg';
export { default as IconSuitcaseFilled } from './svg/suitcase-filled.svg';
export { default as IconSun } from './svg/sun.svg';
export { default as IconSunrise } from './svg/sunrise.svg';
export { default as IconSunset } from './svg/sunset.svg';
export { default as IconSwipe } from './svg/swipe.svg';
export { default as IconTag } from './svg/tag.svg';
export { default as IconTarget } from './svg/target.svg';
export { default as IconThermometer } from './svg/thermometer.svg';
export { default as IconThermostat } from './svg/thermostat.svg';
export { default as IconThumbsDown } from './svg/thumbs-down.svg';
export { default as IconThumbsUp } from './svg/thumbs-up.svg';
export { default as IconTick } from './svg/tick.svg';
export { default as IconTicket } from './svg/ticket.svg';
export { default as IconTickets } from './svg/tickets.svg';
export { default as IconTiktok } from './svg/tiktok.svg';
export { default as IconToggleLeft } from './svg/toggle-left.svg';
export { default as IconToggleRight } from './svg/toggle-right.svg';
export { default as IconTooltip } from './svg/tooltip.svg';
export { default as IconTowel } from './svg/towel.svg';
export { default as IconTrashAlt } from './svg/trash-alt.svg';
export { default as IconTrash } from './svg/trash.svg';
export { default as IconTreatment } from './svg/treatment.svg';
export { default as IconTv } from './svg/tv.svg';
export { default as IconType } from './svg/type.svg';
export { default as IconUmbrella } from './svg/umbrella.svg';
export { default as IconUnderline } from './svg/underline.svg';
export { default as IconUploadCloud } from './svg/upload-cloud.svg';
export { default as IconUpload } from './svg/upload.svg';
export { default as IconUserCheck } from './svg/user-check.svg';
export { default as IconUserMinus } from './svg/user-minus.svg';
export { default as IconUserPlus } from './svg/user-plus.svg';
export { default as IconUser } from './svg/user.svg';
export { default as IconUsers } from './svg/users.svg';
export { default as IconVideo } from './svg/video.svg';
export { default as IconVideos } from './svg/videos.svg';
export { default as IconVolume1 } from './svg/volume-1.svg';
export { default as IconVolume2 } from './svg/volume-2.svg';
export { default as IconVolumeX } from './svg/volume-x.svg';
export { default as IconVolume } from './svg/volume.svg';
export { default as IconVoucher } from './svg/voucher.svg';
export { default as IconWaterDrop } from './svg/water-drop.svg';
export { default as IconWellnessRetreat } from './svg/wellness-retreat.svg';
export { default as IconWifiOff } from './svg/wifi-off.svg';
export { default as IconWifi } from './svg/wifi.svg';
export { default as IconWineGlass } from './svg/wine-glass.svg';
export { default as IconWoman } from './svg/woman.svg';
export { default as IconX } from './svg/x.svg';
export { default as IconYoutube } from './svg/youtube.svg';
export { default as IconZoomIn } from './svg/zoom-in.svg';
export { default as IconZoomOut } from './svg/zoom-out.svg';
export { default as IconZoover } from './svg/zoover.svg';
